import React from 'react';
import Hero from '../components/Hero';
import Approach from '../components/Approach';
import Portfolio from '../components/Portfolio';
import ServicesSummary from '../components/ServicesSummary';
import WhyChoose from '../components/WhyChoose';
import FAQ from '../components/FAQ';
import RevealOnScroll from '../components/RevealOnScroll';

const Home = () => {
  return (
    <div className="home-page">
      <RevealOnScroll>
        <Hero />
      </RevealOnScroll>
      <RevealOnScroll>
        <Approach />
      </RevealOnScroll>
      <RevealOnScroll>
        <Portfolio />
      </RevealOnScroll>
      <RevealOnScroll>
        <ServicesSummary />
      </RevealOnScroll>
      <RevealOnScroll>
        <WhyChoose />
      </RevealOnScroll>
      <RevealOnScroll>
        <FAQ />
      </RevealOnScroll>
    </div>
  );
};

export default Home;
